import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/diaries/$diaryId/edit/tracker/$trackerId/tracker-title')({
  component: () => <div>Hello /_app/diary/$diaryId/tracker/$trackerId/edit/tracker-title!</div>
})